<template>
  <!-- <v-tabs
    v-model="selectedTab"
    class="pa-2"
    show-arrows
    center-active
    centered
    :grow="viewConfig.tabs.length >= 3"
    :background-color="theme.appBar.other.bg"
    :dark="theme.appBar.other.dark"
    slider-size="5"
    slider-color="secondary"
  > -->
  <v-tabs
    v-model="selectedTab"
    class="pa-2"
    show-arrows
    center-active
    centered
    light
    :grow="viewConfig.tabs.length >= 3"
    :background-color="theme.appBar.other.bg"
    color="red"
    slider-size="3"
    slider-color="primary"
  >
    <v-tab style="font-size: 11px" v-for="(tab, index) in viewConfig.tabs" :key="index" small>
      {{ $t(tab.title) }}
    </v-tab>
  </v-tabs>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    tabsViewConfig: {
      type: Object,
    },
  },
  data: () => ({}),
  computed: {
    ...mapState({
      theme: (state) => state.theme.appliedTheme.components,
      searchFieldTheme: (state) => state.theme.appliedTheme.components.searchField,
    }),
    ...mapGetters({
      displayedDocumentName: 'documents/getDisplayedDocumentTitle',
    }),
    viewConfig() {
      return this.$route.meta.viewConfig;
    },
    selectedTab: {
      get() {
        return this.$store.state.tabview.selectedTabByPath[this.$route.path];
      },
      set(value) {
        console.debug('set selectedTab');
        this.$store.commit('tabview/setSelectedTab', { path: this.$route.path, selectedTabIndex: value }, { root: true });
      },
    },
  },
};
</script>
